import { useSelector, useDispatch } from 'react-redux';
import { addNotification, removeNotification, clearNotifications, selectNotifications } from '../store/slices/uiSlice';

// Custom hook for managing notifications
export const useNotifications = () => {
  const dispatch = useDispatch();
  const notifications = useSelector(selectNotifications);

  const showNotification = (notification) => {
    dispatch(addNotification({
      type: 'info',
      duration: 5000,
      ...notification,
    }));
  };

  const showSuccess = (message, options = {}) => {
    showNotification({
      type: 'success',
      message,
      ...options,
    });
  };

  const showError = (message, options = {}) => {
    showNotification({
      type: 'error',
      message,
      duration: 8000, // Errors stay longer
      ...options,
    });
  };

  const showWarning = (message, options = {}) => {
    showNotification({
      type: 'warning',
      message,
      duration: 6000,
      ...options,
    });
  };

  const showInfo = (message, options = {}) => {
    showNotification({
      type: 'info',
      message,
      ...options,
    });
  };

  const hideNotification = (id) => {
    dispatch(removeNotification(id));
  };

  const clearAll = () => {
    dispatch(clearNotifications());
  };

  return {
    notifications,
    showNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    hideNotification,
    clearAll,
  };
};

export default useNotifications;